/*
 #*===================================================================
 #*
 #* Licensed Materials - Property of GameTimeFootage Inc.
 #*
 #* Copyright NextPro 2019. All Rights Reserved.
 #*
 #*===================================================================
 */

import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ModalService } from '@shared/services';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-hr-selection-modal',
  templateUrl: './hr-selection-modal.component.html',
  styleUrls: ['./hr-selection-modal.component.scss'],
})
export class HrSelectionModalComponent implements OnInit {
  @Input() availableReels = [];
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  constructor(private modalService: ModalService, private router: Router, private route: ActivatedRoute) {}

  ngOnInit() {}

  close(purchaseId = null) {
    this.closeModal.emit(purchaseId ? { formId: purchaseId } : null);
    this.modalService.hideModal();
  }

  goToForm(purchaseId: number) {
    // this.router.navigate(['./', purchaseId], { relativeTo: this.route });
    this.close(purchaseId);
  }
}
